export default "__VITE_ASSET__B5XPCQt9__"